import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Crown } from "lucide-react";
import { api } from "@/lib/api";
import VipMedallion from "./VipMedallion";
import { VIP_BY_TIER, fmtCoins } from "@/lib/vipTiers";

// Coin Store nudge: "200,000 coins to Black Panda VIP" — server-calculated purchase progress for this month.
export default function VipPurchaseNudge({ className = "" }) {
  const [me, setMe] = useState(null);
  useEffect(() => { api.get("/vip/me").then(({ data }) => setMe(data)).catch(() => {}); }, []);
  if (!me || me.excluded) return null;
  const cur = me.tier ? VIP_BY_TIER[me.tier] : null;
  const next = me.next ? VIP_BY_TIER[me.next.tier] : null;
  const floor = cur ? cur.coins : 0;
  const pct = next ? Math.min(100, Math.round(((me.verified_coins - floor) / (next.coins - floor)) * 100)) : 100;
  const target = next || cur;
  return (
    <Link to="/vip" data-testid="vip-purchase-nudge" className={`group flex items-center gap-4 p-4 border ${target?.border || "border-white/10"} bg-black/40 hover:bg-white/[0.04] transition-colors ${className}`}>
      <VipMedallion tier={target?.tier || "green"} size="md" className="shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 flex items-center gap-1.5"><Crown size={11} className="text-amber-300" /> Monthly VIP · {me.month}</div>
        {next ? (
          <div className={`font-display text-xl leading-tight ${next.text}`} data-testid="vip-purchase-nudge-text">
            {fmtCoins(me.next.coins_remaining)} coins to {next.label}
          </div>
        ) : (
          <div className="font-display text-xl leading-tight text-amber-200" data-testid="vip-purchase-nudge-text">Panda Boss unlocked this month</div>
        )}
        <div className="text-[11px] text-zinc-500 mt-0.5">{fmtCoins(me.verified_coins)} verified coins purchased so far · resets on the 1st · gifts don&apos;t count</div>
        <div className="h-1.5 bg-white/5 mt-2 overflow-hidden"><div className={`h-full bg-gradient-to-r ${target?.ring || ""}`} style={{ width: `${pct}%` }} data-testid="vip-purchase-nudge-bar" /></div>
      </div>
      <span className="text-[10px] uppercase tracking-widest text-rose-400 group-hover:text-rose-300 flex items-center gap-0.5 shrink-0">Badges <ChevronRight size={12} /></span>
    </Link>
  );
}
